module.exports = __webpack_public_path__ + "static/img/zhengcheqipei.f9353e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/zhengcheqipei.png
// module id = 390
// module chunks = 12